import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { UserInputActions } from './user-input.actions';
import { MessagesActions } from '../messages/messages.actions';
import { LiveChatActions } from '../live-chat/live-chat.actions';
import { PostEscalationCurationActions } from '../post-escalation-curation/post-escalation-curation.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { SafeSendActions } from '../safe-send/safe-send.actions';
import { MessageSubType } from '../../types/enum';

export const initialState: Readonly<boolean> = false;

export const userInputFeature = createFeature({
  name: 'userInput',
  reducer: createReducer(
    initialState,
    on(
      UserInputActions.enableUserInput,
      MessagesActions.dialogApiFailed,
      LiveChatActions.receiveOperatorMessage,
      SafeSendActions.updateSafeSend,
      () => {
        return false; // Input is Enabled
      }
    ),
    on(
      UserInputActions.disableUserInput,
      MessagesActions.callDialogApi,
      MessagesActions.addMessagesWithDelay,
      LiveChatActions.waitingForAnAgent,
      LiveChatActions.escalateToLiveChat,
      MessagesActions.askUserToLogin,
      PostEscalationCurationActions.updateSelectedItems,
      () => {
        return true; // Input is disabled
      }
    ),
    on(MessagesActions.addNewMessages, (state, { messages }) => {
      return (
        messages?.length &&
        (messages[0].messageSubType == MessageSubType.SAFESEND ||
          messages[0].messageSubType == MessageSubType.LIVE_CHAT_UNAVAILABLE ||
          messages[0].messageSubType == MessageSubType.ASK_TO_LOGIN)
      ); // disabled if safe-send or live-chat-unavailable
    })
  ),
});

export const { selectUserInputState } = userInputFeature;

export function provideUserInputFeature() {
  return makeEnvironmentProviders([provideState(userInputFeature)]);
}
